import { Injectable, signal, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie';
@Injectable({
  providedIn: 'root',
})
export class CookiesConsentService {
  private cookieService = inject(CookieService);


  public cookiesConsented = signal(this.cookieService.get('cookie-consent'));

  public setCookiesConsent() {
    this.cookieService.put('cookie-consent', 'consented');
    this.cookiesConsented.set('consented');
  }
}
